export default __webpack_public_path__ + "static/cta-desktop-ddfe10e1ab9bc970777a263381331fc0.jpg";